import { useTranslation } from 'react-i18next';
import { regionOptions, yearOptions } from '@/mocks/movies';
import type { FilterState } from '@/utils/media';

interface FilterPanelProps {
  filter: FilterState;
  onChange: (next: Partial<FilterState>) => void;
}

function ChipGroup({
  label,
  options,
  value,
  onSelect,
}: {
  label: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div>
      <h4 className="mb-2.5 font-heading text-sm font-semibold text-foreground-800">{label}</h4>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = value === opt;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onSelect(opt)}
              className={`rounded-full px-3 py-1.5 text-xs font-medium transition cursor-pointer whitespace-nowrap ${
                active
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({ filter, onChange }: FilterPanelProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <ChipGroup label={t('region')} options={regionOptions} value={filter.region} onSelect={(v) => onChange({ region: v })} />
      <ChipGroup label={t('year')} options={yearOptions} value={filter.year} onSelect={(v) => onChange({ year: v })} />
      <div>
        <h4 className="mb-2.5 font-heading text-sm font-semibold text-foreground-800">{t('sort')}</h4>
        <div className="inline-flex rounded-full bg-background-100 p-1">
          {[t('sortLatest'), t('sortHot'), t('sortRating')].map((opt) => {
            const active = filter.sort === opt;
            return (
              <button
                key={opt}
                type="button"
                onClick={() => onChange({ sort: opt })}
                className={`rounded-full px-3.5 py-1.5 text-xs font-medium transition cursor-pointer whitespace-nowrap ${
                  active ? 'bg-accent-500 text-accent-950' : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>
      <button
        type="button"
        onClick={() => onChange({ region: '全部', year: '全部', sort: t('sortLatest') })}
        className="flex items-center justify-center gap-1.5 rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-600 transition hover:bg-background-100 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-refresh-line"></i>
        {t('resetFilter')}
      </button>
    </div>
  );
}